import createAction from './';

export const CHANGE_ORGANIZATION_LOGO = createAction('CHANGE_ORGANIZATION_LOGO');

export const changeOrganizationLogo = () => (dispatch, getState) => {
  const state = getState();
  const { siteLogo, siteLogoLabels } = state.auth.organizations;
  const selectedOrganizationLogo = state.auth.organizations.organizationLogo;
  const selectedOrganizationLogoLabels = state.auth.organizations.organizationLogoLabels;
  const organizationLogo = selectedOrganizationLogo === undefined ? siteLogo : selectedOrganizationLogo;
  const organizationLogoLabels = selectedOrganizationLogoLabels.length ? selectedOrganizationLogoLabels : siteLogoLabels;

  return dispatch({
    type: CHANGE_ORGANIZATION_LOGO,
    payload: { organizationLogo, organizationLogoLabels },
  });
};
